import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'pd-app-title',
  templateUrl: './app-title.component.html',
  styleUrls: ['./app-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterLink],
})
export class AppTitleComponent {
  @Input() sizeClass: string;
}
